module.exports = __webpack_public_path__ + "img/fortune-main-photo.f64a3560.png";